import React from 'react';

interface Props {
  examName: string;
}

const UpsellContent = (props) => {
  const DefaultUpsellContent = () => (
    <ul className="u-padding-L-m">
      <li>Expert Video Lessons</li>
      <li>Practice Questions</li>
      <li>Score-Improvement Guarantee</li>
      <li>No Questions Asked Money-Back Guarantee</li>
    </ul>
  );

  const ExamUpsellContent = React.lazy(() => {
    return import(`./exams/${props.examName.trim().toLowerCase().replace(/ /g, '_')}`).catch((error) => {
      return { default: DefaultUpsellContent };
    })
  });

  return <ExamUpsellContent />;
};

export default UpsellContent;
